<template>
  <el-dialog
    append-to-body
    width="600px"
    title="审核通过"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="130px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item label="申请人:">
        {{ info.name }}
      </el-form-item>
      <el-form-item label="联系电话:">
        {{ info.phone }}
      </el-form-item>
      <el-form-item label="代理区域:">
        <span
          >{{ info.province_str }}{{ info.city_str }}{{ info.area_str
          }}{{ info.street_str }}</span
        >
      </el-form-item>
      <el-form-item label="门头照片:">
        <el-image
          style="width: 50px; height: 50px"
          :src="info && info.images ? info.images[0] : ''"
          :preview-src-list="info.images"
        ></el-image>
      </el-form-item>
      <el-form-item label="创建时间:">
        {{ info.create_time }}
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="center">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      loading: false,
      info: {},
      form: {
        loading: false,
      },
    };
  },
  methods: {
    // 获取详情
    getDetail(row) {
      this.info = row;
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    // 提交
    confirm() {
      // this.$refs.elFormDom.validate((valid) => {
      //   if (valid) {
          this.form.loading = true;
          this.$http
            .post("/admin/flex_agency/check", {
              id: this.info.id,
              status: 1,
            })
            .then((res) => {
              if (res.code === 1) {
                this.$message.success("操作成功！");
                this.$emit("success");
                this.toggle(false);
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        // }
      // });
    },
  },
};
</script>
